import React, {useState} from "react";
import './sdAccordion.scss';

function SDAccordion (props) {
    const [check, setCheck] = useState(false);
    return (
        <div className="mainAcc" onClick={() => {setCheck(!check)}}>
            <div className="topicArea">
                <div>{props.topic}</div>
                <div className={`main ${check ?  'accMinus' : 'accPlus'}`} >
                    {check}
                </div>
            </div>
            <div className={`contentArea ${check ? 'accShow' : 'acchide'}`}>
                {props.content}
            </div>
        </div>
    )
}

export default SDAccordion;